import styled from 'styled-components';

interface RuleInfoProps {
  hasLogicalColumn: boolean;
  hasValue2Column: boolean;
}

const RuleInfo = styled.div<RuleInfoProps>`
  padding: ${(props): string => props.theme.spaces.md};
  border-top: solid 0.1rem ${(props): string => props.theme.colors.iceGray};

  display: grid;
  grid-template-columns: ${(props): string =>
      props.hasLogicalColumn ? '4rem 17rem' : '22rem'} ${(props): string =>
      props.hasValue2Column ? 'auto auto 1fr' : '1fr'} 3.4rem 3.4rem;
  grid-column-gap: ${(props): string => props.theme.spaces.md};
`;

export { RuleInfo };
